import { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ShoppingCart, MapPin, Wifi, Clock, ChevronRight } from 'lucide-react';

// Country data with coordinates — all 209 eSIM destinations
export const COUNTRIES_DATA = [
  { code: 'AD', name: 'Andorra', lat: 42.5, lng: 1.5, region: 'europe' },
  { code: 'AE', name: 'Emirati Arabi', lat: 24.5, lng: 54.4, region: 'asia' },
  { code: 'AF', name: 'Afghanistan', lat: 34.5, lng: 69.2, region: 'asia' },
  { code: 'AG', name: 'Antigua e Barbuda', lat: 17.1, lng: -61.8, region: 'americas' },
  { code: 'AI', name: 'Anguilla', lat: 18.2, lng: -63.1, region: 'americas' },
  { code: 'AL', name: 'Albania', lat: 41.3, lng: 19.8, region: 'europe' },
  { code: 'AM', name: 'Armenia', lat: 40.2, lng: 44.5, region: 'asia' },
  { code: 'AN', name: 'Antille Olandesi', lat: 12.2, lng: -68.9, region: 'americas' },
  { code: 'AR', name: 'Argentina', lat: -34.6, lng: -58.4, region: 'americas' },
  { code: 'AT', name: 'Austria', lat: 48.2, lng: 16.4, region: 'europe' },
  { code: 'AU', name: 'Australia', lat: -33.9, lng: 151.2, region: 'oceania' },
  { code: 'AW', name: 'Aruba', lat: 12.5, lng: -70.0, region: 'americas' },
  { code: 'AX', name: 'Isole Aland', lat: 60.1, lng: 20.0, region: 'europe' },
  { code: 'AZ', name: 'Azerbaigian', lat: 40.4, lng: 49.9, region: 'asia' },
  { code: 'BA', name: 'Bosnia', lat: 43.9, lng: 18.4, region: 'europe' },
  { code: 'BB', name: 'Barbados', lat: 13.1, lng: -59.6, region: 'americas' },
  { code: 'BD', name: 'Bangladesh', lat: 23.8, lng: 90.4, region: 'asia' },
  { code: 'BE', name: 'Belgio', lat: 50.8, lng: 4.4, region: 'europe' },
  { code: 'BF', name: 'Burkina Faso', lat: 12.4, lng: -1.5, region: 'africa' },
  { code: 'BG', name: 'Bulgaria', lat: 42.7, lng: 23.3, region: 'europe' },
  { code: 'BH', name: 'Bahrein', lat: 26.2, lng: 50.6, region: 'asia' },
  { code: 'BJ', name: 'Benin', lat: 6.5, lng: 2.6, region: 'africa' },
  { code: 'BL', name: 'Saint-Barthelemy', lat: 17.9, lng: -62.8, region: 'americas' },
  { code: 'BM', name: 'Bermuda', lat: 32.3, lng: -64.8, region: 'americas' },
  { code: 'BN', name: 'Brunei', lat: 4.9, lng: 115.0, region: 'asia' },
  { code: 'BO', name: 'Bolivia', lat: -16.5, lng: -68.1, region: 'americas' },
  { code: 'BR', name: 'Brasile', lat: -22.9, lng: -43.2, region: 'americas' },
  { code: 'BS', name: 'Bahamas', lat: 25.0, lng: -77.3, region: 'americas' },
  { code: 'BT', name: 'Bhutan', lat: 27.5, lng: 89.6, region: 'asia' },
  { code: 'BW', name: 'Botswana', lat: -24.7, lng: 25.9, region: 'africa' },
  { code: 'BY', name: 'Bielorussia', lat: 53.9, lng: 27.6, region: 'europe' },
  { code: 'BZ', name: 'Belize', lat: 17.5, lng: -88.2, region: 'americas' },
  { code: 'CA', name: 'Canada', lat: 45.4, lng: -75.7, region: 'americas' },
  { code: 'CD', name: 'RD Congo', lat: -4.3, lng: 15.3, region: 'africa' },
  { code: 'CF', name: 'Centrafrica', lat: 4.4, lng: 18.6, region: 'africa' },
  { code: 'CG', name: 'Congo', lat: -4.3, lng: 15.3, region: 'africa' },
  { code: 'CH', name: 'Svizzera', lat: 46.9, lng: 7.4, region: 'europe' },
  { code: 'CI', name: "Costa d'Avorio", lat: 5.3, lng: -4.0, region: 'africa' },
  { code: 'CL', name: 'Cile', lat: -33.4, lng: -70.6, region: 'americas' },
  { code: 'CM', name: 'Camerun', lat: 3.9, lng: 11.5, region: 'africa' },
  { code: 'CN', name: 'Cina', lat: 39.9, lng: 116.4, region: 'asia' },
  { code: 'CO', name: 'Colombia', lat: 4.7, lng: -74.1, region: 'americas' },
  { code: 'CR', name: 'Costa Rica', lat: 9.9, lng: -84.1, region: 'americas' },
  { code: 'CU', name: 'Cuba', lat: 23.1, lng: -82.4, region: 'americas' },
  { code: 'CV', name: 'Capo Verde', lat: 14.9, lng: -23.5, region: 'africa' },
  { code: 'CW', name: 'Curacao', lat: 12.2, lng: -69.0, region: 'americas' },
  { code: 'CY', name: 'Cipro', lat: 35.2, lng: 33.4, region: 'europe' },
  { code: 'CZ', name: 'Cechia', lat: 50.1, lng: 14.4, region: 'europe' },
  { code: 'DE', name: 'Germania', lat: 52.5, lng: 13.4, region: 'europe' },
  { code: 'DK', name: 'Danimarca', lat: 55.7, lng: 12.6, region: 'europe' },
  { code: 'DM', name: 'Dominica', lat: 15.3, lng: -61.4, region: 'americas' },
  { code: 'DO', name: 'Rep. Dominicana', lat: 18.5, lng: -69.9, region: 'americas' },
  { code: 'DZ', name: 'Algeria', lat: 36.8, lng: 3.1, region: 'africa' },
  { code: 'EC', name: 'Ecuador', lat: -0.2, lng: -78.5, region: 'americas' },
  { code: 'EE', name: 'Estonia', lat: 59.4, lng: 24.7, region: 'europe' },
  { code: 'EG', name: 'Egitto', lat: 30.0, lng: 31.2, region: 'africa' },
  { code: 'EH', name: 'Sahara Occ.', lat: 24.2, lng: -13.0, region: 'africa' },
  { code: 'ES', name: 'Spagna', lat: 40.4, lng: -3.7, region: 'europe' },
  { code: 'ET', name: 'Etiopia', lat: 9.0, lng: 38.7, region: 'africa' },
  { code: 'FI', name: 'Finlandia', lat: 60.2, lng: 24.9, region: 'europe' },
  { code: 'FJ', name: 'Fiji', lat: -18.1, lng: 178.4, region: 'oceania' },
  { code: 'FO', name: 'Isole Faroe', lat: 62.0, lng: -6.8, region: 'europe' },
  { code: 'FR', name: 'Francia', lat: 48.9, lng: 2.3, region: 'europe' },
  { code: 'GA', name: 'Gabon', lat: 0.4, lng: 9.5, region: 'africa' },
  { code: 'GB', name: 'Regno Unito', lat: 51.5, lng: -0.1, region: 'europe' },
  { code: 'GD', name: 'Grenada', lat: 12.1, lng: -61.7, region: 'americas' },
  { code: 'GE', name: 'Georgia', lat: 41.7, lng: 44.8, region: 'europe' },
  { code: 'GF', name: 'Guyana Francese', lat: 4.9, lng: -52.3, region: 'americas' },
  { code: 'GG', name: 'Guernsey', lat: 49.5, lng: -2.5, region: 'europe' },
  { code: 'GH', name: 'Ghana', lat: 5.6, lng: -0.2, region: 'africa' },
  { code: 'GI', name: 'Gibilterra', lat: 36.1, lng: -5.4, region: 'europe' },
  { code: 'GL', name: 'Groenlandia', lat: 64.2, lng: -51.7, region: 'europe' },
  { code: 'GN', name: 'Guinea', lat: 9.5, lng: -13.7, region: 'africa' },
  { code: 'GP', name: 'Guadalupa', lat: 16.3, lng: -61.5, region: 'americas' },
  { code: 'GR', name: 'Grecia', lat: 37.98, lng: 23.73, region: 'europe' },
  { code: 'GT', name: 'Guatemala', lat: 14.6, lng: -90.5, region: 'americas' },
  { code: 'GU', name: 'Guam', lat: 13.5, lng: 144.8, region: 'oceania' },
  { code: 'GW', name: 'Guinea-Bissau', lat: 11.9, lng: -15.6, region: 'africa' },
  { code: 'GY', name: 'Guyana', lat: 6.8, lng: -58.2, region: 'americas' },
  { code: 'HK', name: 'Hong Kong', lat: 22.3, lng: 114.2, region: 'asia' },
  { code: 'HN', name: 'Honduras', lat: 14.1, lng: -87.2, region: 'americas' },
  { code: 'HR', name: 'Croazia', lat: 45.8, lng: 16.0, region: 'europe' },
  { code: 'HT', name: 'Haiti', lat: 18.5, lng: -72.3, region: 'americas' },
  { code: 'HU', name: 'Ungheria', lat: 47.5, lng: 19.0, region: 'europe' },
  { code: 'IC', name: 'Canarie', lat: 28.1, lng: -15.4, region: 'europe' },
  { code: 'ID', name: 'Indonesia', lat: -6.2, lng: 106.8, region: 'asia' },
  { code: 'IE', name: 'Irlanda', lat: 53.3, lng: -6.3, region: 'europe' },
  { code: 'IL', name: 'Israele', lat: 31.8, lng: 35.2, region: 'asia' },
  { code: 'IM', name: 'Isola di Man', lat: 54.2, lng: -4.5, region: 'europe' },
  { code: 'IN', name: 'India', lat: 28.6, lng: 77.2, region: 'asia' },
  { code: 'IQ', name: 'Iraq', lat: 33.3, lng: 44.4, region: 'asia' },
  { code: 'IR', name: 'Iran', lat: 35.7, lng: 51.4, region: 'asia' },
  { code: 'IS', name: 'Islanda', lat: 64.1, lng: -21.9, region: 'europe' },
  { code: 'IT', name: 'Italia', lat: 41.9, lng: 12.5, region: 'europe' },
  { code: 'JE', name: 'Jersey', lat: 49.2, lng: -2.1, region: 'europe' },
  { code: 'JM', name: 'Giamaica', lat: 18.0, lng: -76.8, region: 'americas' },
  { code: 'JO', name: 'Giordania', lat: 31.9, lng: 35.9, region: 'asia' },
  { code: 'JP', name: 'Giappone', lat: 35.7, lng: 139.7, region: 'asia' },
  { code: 'KE', name: 'Kenya', lat: -1.3, lng: 36.8, region: 'africa' },
  { code: 'KG', name: 'Kirghizistan', lat: 42.9, lng: 74.6, region: 'asia' },
  { code: 'KH', name: 'Cambogia', lat: 11.6, lng: 104.9, region: 'asia' },
  { code: 'KM', name: 'Comore', lat: -11.7, lng: 43.3, region: 'africa' },
  { code: 'KN', name: 'Saint Kitts', lat: 17.3, lng: -62.7, region: 'americas' },
  { code: 'KR', name: 'Corea del Sud', lat: 37.6, lng: 127.0, region: 'asia' },
  { code: 'KW', name: 'Kuwait', lat: 29.4, lng: 48.0, region: 'asia' },
  { code: 'KY', name: 'Isole Cayman', lat: 19.3, lng: -81.4, region: 'americas' },
  { code: 'KZ', name: 'Kazakistan', lat: 51.2, lng: 71.4, region: 'asia' },
  { code: 'LA', name: 'Laos', lat: 17.97, lng: 102.6, region: 'asia' },
  { code: 'LC', name: 'Santa Lucia', lat: 14.0, lng: -61.0, region: 'americas' },
  { code: 'LI', name: 'Liechtenstein', lat: 47.1, lng: 9.5, region: 'europe' },
  { code: 'LK', name: 'Sri Lanka', lat: 6.9, lng: 79.9, region: 'asia' },
  { code: 'LR', name: 'Liberia', lat: 6.3, lng: -10.8, region: 'africa' },
  { code: 'LS', name: 'Lesotho', lat: -29.3, lng: 27.5, region: 'africa' },
  { code: 'LT', name: 'Lituania', lat: 54.7, lng: 25.3, region: 'europe' },
  { code: 'LU', name: 'Lussemburgo', lat: 49.6, lng: 6.1, region: 'europe' },
  { code: 'LV', name: 'Lettonia', lat: 56.9, lng: 24.1, region: 'europe' },
  { code: 'MA', name: 'Marocco', lat: 33.97, lng: -6.8, region: 'africa' },
  { code: 'MC', name: 'Monaco', lat: 43.7, lng: 7.4, region: 'europe' },
  { code: 'MD', name: 'Moldavia', lat: 47.0, lng: 28.8, region: 'europe' },
  { code: 'ME', name: 'Montenegro', lat: 42.4, lng: 19.3, region: 'europe' },
  { code: 'MF', name: 'Saint Martin', lat: 18.1, lng: -63.0, region: 'americas' },
  { code: 'MG', name: 'Madagascar', lat: -18.9, lng: 47.5, region: 'africa' },
  { code: 'MK', name: 'Macedonia del Nord', lat: 42.0, lng: 21.4, region: 'europe' },
  { code: 'ML', name: 'Mali', lat: 12.6, lng: -8.0, region: 'africa' },
  { code: 'MM', name: 'Myanmar', lat: 16.9, lng: 96.2, region: 'asia' },
  { code: 'MN', name: 'Mongolia', lat: 47.9, lng: 106.9, region: 'asia' },
  { code: 'MO', name: 'Macao', lat: 22.2, lng: 113.5, region: 'asia' },
  { code: 'MQ', name: 'Martinica', lat: 14.6, lng: -61.0, region: 'americas' },
  { code: 'MR', name: 'Mauritania', lat: 18.1, lng: -15.98, region: 'africa' },
  { code: 'MS', name: 'Montserrat', lat: 16.7, lng: -62.2, region: 'americas' },
  { code: 'MT', name: 'Malta', lat: 35.9, lng: 14.5, region: 'europe' },
  { code: 'MU', name: 'Mauritius', lat: -20.2, lng: 57.5, region: 'africa' },
  { code: 'MV', name: 'Maldive', lat: 4.2, lng: 73.5, region: 'asia' },
  { code: 'MW', name: 'Malawi', lat: -13.97, lng: 33.8, region: 'africa' },
  { code: 'MX', name: 'Messico', lat: 19.4, lng: -99.1, region: 'americas' },
  { code: 'MY', name: 'Malesia', lat: 3.1, lng: 101.7, region: 'asia' },
  { code: 'MZ', name: 'Mozambico', lat: -25.97, lng: 32.6, region: 'africa' },
  { code: 'NA', name: 'Namibia', lat: -22.6, lng: 17.1, region: 'africa' },
  { code: 'NC', name: 'Nuova Caledonia', lat: -22.3, lng: 166.5, region: 'oceania' },
  { code: 'NE', name: 'Niger', lat: 13.5, lng: 2.1, region: 'africa' },
  { code: 'NG', name: 'Nigeria', lat: 9.1, lng: 7.5, region: 'africa' },
  { code: 'NI', name: 'Nicaragua', lat: 12.1, lng: -86.3, region: 'americas' },
  { code: 'NL', name: 'Paesi Bassi', lat: 52.4, lng: 4.9, region: 'europe' },
  { code: 'NO', name: 'Norvegia', lat: 59.9, lng: 10.8, region: 'europe' },
  { code: 'NP', name: 'Nepal', lat: 27.7, lng: 85.3, region: 'asia' },
  { code: 'NR', name: 'Nauru', lat: -0.5, lng: 166.9, region: 'oceania' },
  { code: 'NZ', name: 'Nuova Zelanda', lat: -41.3, lng: 174.8, region: 'oceania' },
  { code: 'OM', name: 'Oman', lat: 23.6, lng: 58.5, region: 'asia' },
  { code: 'PA', name: 'Panama', lat: 9.0, lng: -79.5, region: 'americas' },
  { code: 'PE', name: 'Peru', lat: -12.0, lng: -77.0, region: 'americas' },
  { code: 'PF', name: 'Polinesia Fr.', lat: -17.5, lng: -149.6, region: 'oceania' },
  { code: 'PG', name: 'Papua N.G.', lat: -6.3, lng: 147.2, region: 'oceania' },
  { code: 'PH', name: 'Filippine', lat: 14.6, lng: 121.0, region: 'asia' },
  { code: 'PK', name: 'Pakistan', lat: 33.7, lng: 73.0, region: 'asia' },
  { code: 'PL', name: 'Polonia', lat: 52.2, lng: 21.0, region: 'europe' },
  { code: 'PR', name: 'Porto Rico', lat: 18.5, lng: -66.1, region: 'americas' },
  { code: 'PS', name: 'Palestina', lat: 31.9, lng: 35.2, region: 'asia' },
  { code: 'PT', name: 'Portogallo', lat: 38.7, lng: -9.1, region: 'europe' },
  { code: 'PW', name: 'Palau', lat: 7.5, lng: 134.6, region: 'oceania' },
  { code: 'PY', name: 'Paraguay', lat: -25.3, lng: -57.6, region: 'americas' },
  { code: 'QA', name: 'Qatar', lat: 25.3, lng: 51.5, region: 'asia' },
  { code: 'RE', name: 'Riunione', lat: -21.1, lng: 55.5, region: 'africa' },
  { code: 'RO', name: 'Romania', lat: 44.4, lng: 26.1, region: 'europe' },
  { code: 'RS', name: 'Serbia', lat: 44.8, lng: 20.5, region: 'europe' },
  { code: 'RU', name: 'Russia', lat: 55.8, lng: 37.6, region: 'europe' },
  { code: 'RW', name: 'Ruanda', lat: -1.9, lng: 29.9, region: 'africa' },
  { code: 'SA', name: 'Arabia Saudita', lat: 24.7, lng: 46.7, region: 'asia' },
  { code: 'SC', name: 'Seychelles', lat: -4.6, lng: 55.5, region: 'africa' },
  { code: 'SD', name: 'Sudan', lat: 15.6, lng: 32.5, region: 'africa' },
  { code: 'SE', name: 'Svezia', lat: 59.3, lng: 18.1, region: 'europe' },
  { code: 'SG', name: 'Singapore', lat: 1.3, lng: 103.8, region: 'asia' },
  { code: 'SI', name: 'Slovenia', lat: 46.1, lng: 14.5, region: 'europe' },
  { code: 'SK', name: 'Slovacchia', lat: 48.1, lng: 17.1, region: 'europe' },
  { code: 'SL', name: 'Sierra Leone', lat: 8.5, lng: -13.2, region: 'africa' },
  { code: 'SM', name: 'San Marino', lat: 43.9, lng: 12.4, region: 'europe' },
  { code: 'SN', name: 'Senegal', lat: 14.7, lng: -17.5, region: 'africa' },
  { code: 'SR', name: 'Suriname', lat: 5.8, lng: -55.2, region: 'americas' },
  { code: 'SV', name: 'El Salvador', lat: 13.7, lng: -89.2, region: 'americas' },
  { code: 'SX', name: 'Sint Maarten', lat: 18.0, lng: -63.0, region: 'americas' },
  { code: 'SZ', name: 'Eswatini', lat: -26.3, lng: 31.1, region: 'africa' },
  { code: 'TC', name: 'Turks e Caicos', lat: 21.8, lng: -72.2, region: 'americas' },
  { code: 'TD', name: 'Ciad', lat: 12.1, lng: 15.0, region: 'africa' },
  { code: 'TG', name: 'Togo', lat: 6.1, lng: 1.2, region: 'africa' },
  { code: 'TH', name: 'Thailandia', lat: 13.8, lng: 100.5, region: 'asia' },
  { code: 'TJ', name: 'Tagikistan', lat: 38.6, lng: 68.8, region: 'asia' },
  { code: 'TN', name: 'Tunisia', lat: 36.8, lng: 10.2, region: 'africa' },
  { code: 'TO', name: 'Tonga', lat: -21.2, lng: -175.2, region: 'oceania' },
  { code: 'TR', name: 'Turchia', lat: 41.0, lng: 29.0, region: 'europe' },
  { code: 'TT', name: 'Trinidad e Tobago', lat: 10.7, lng: -61.5, region: 'americas' },
  { code: 'TW', name: 'Taiwan', lat: 25.0, lng: 121.5, region: 'asia' },
  { code: 'TZ', name: 'Tanzania', lat: -6.8, lng: 37.3, region: 'africa' },
  { code: 'UA', name: 'Ucraina', lat: 50.4, lng: 30.5, region: 'europe' },
  { code: 'UG', name: 'Uganda', lat: 0.3, lng: 32.6, region: 'africa' },
  { code: 'US', name: 'USA', lat: 40.7, lng: -74.0, region: 'americas' },
  { code: 'US-HI', name: 'Hawaii', lat: 21.3, lng: -157.8, region: 'americas' },
  { code: 'UY', name: 'Uruguay', lat: -34.9, lng: -56.2, region: 'americas' },
  { code: 'UZ', name: 'Uzbekistan', lat: 41.3, lng: 69.3, region: 'asia' },
  { code: 'VA', name: 'Vaticano', lat: 41.9, lng: 12.5, region: 'europe' },
  { code: 'VC', name: 'Saint Vincent', lat: 13.2, lng: -61.2, region: 'americas' },
  { code: 'VE', name: 'Venezuela', lat: 10.5, lng: -66.9, region: 'americas' },
  { code: 'VG', name: 'Isole Vergini Br.', lat: 18.4, lng: -64.6, region: 'americas' },
  { code: 'VN', name: 'Vietnam', lat: 21.0, lng: 105.8, region: 'asia' },
  { code: 'VU', name: 'Vanuatu', lat: -17.7, lng: 168.3, region: 'oceania' },
  { code: 'WS', name: 'Samoa', lat: -13.8, lng: -172.0, region: 'oceania' },
  { code: 'XK', name: 'Kosovo', lat: 42.7, lng: 21.2, region: 'europe' },
  { code: 'YE', name: 'Yemen', lat: 15.4, lng: 44.2, region: 'asia' },
  { code: 'YT', name: 'Mayotte', lat: -12.8, lng: 45.2, region: 'africa' },
  { code: 'ZA', name: 'Sudafrica', lat: -33.9, lng: 18.4, region: 'africa' },
  { code: 'ZM', name: 'Zambia', lat: -15.4, lng: 28.3, region: 'africa' },
];

// Connection arcs between major hubs
export const CONNECTION_ARCS = [
  { from: 'IT', to: 'JP', color: '#14b8a6' },
  { from: 'FR', to: 'US', color: '#14b8a6' },
  { from: 'DE', to: 'AU', color: '#14b8a6' },
  { from: 'GB', to: 'SG', color: '#14b8a6' },
  { from: 'ES', to: 'BR', color: '#14b8a6' },
  { from: 'IT', to: 'TH', color: '#14b8a6' },
  { from: 'PL', to: 'JP', color: '#14b8a6' },
  { from: 'US', to: 'KR', color: '#14b8a6' },
];

export function InteractiveGlobe({ onCountrySelect, searchQuery, products }) {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);
  const [hoveredCountry, setHoveredCountry] = useState(null);
  const [rotation, setRotation] = useState({ x: 0, y: 0 });
  const [targetRotation, setTargetRotation] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [lastMouse, setLastMouse] = useState({ x: 0, y: 0 });
  const animationRef = useRef();

  // Find country for search
  useEffect(() => {
    if (searchQuery) {
      const country = COUNTRIES_DATA.find(c => 
        c.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        c.code.toLowerCase() === searchQuery.toLowerCase()
      );
      if (country) {
        // Rotate globe to show country
        setTargetRotation({
          x: -country.lat * (Math.PI / 180),
          y: -country.lng * (Math.PI / 180)
        });
      }
    }
  }, [searchQuery]);

  // Smooth rotation animation
  useEffect(() => {
    if (targetRotation) {
      const animate = () => {
        setRotation(prev => {
          const dx = (targetRotation.x - prev.x) * 0.05;
          const dy = (targetRotation.y - prev.y) * 0.05;
          
          if (Math.abs(dx) < 0.001 && Math.abs(dy) < 0.001) {
            setTargetRotation(null);
            return targetRotation;
          }
          
          return { x: prev.x + dx, y: prev.y + dy };
        });
        animationRef.current = requestAnimationFrame(animate);
      };
      animationRef.current = requestAnimationFrame(animate);
      return () => cancelAnimationFrame(animationRef.current);
    }
  }, [targetRotation]);

  // Get product info for country
  const getProductForCountry = useCallback((countryCode) => {
    const country = COUNTRIES_DATA.find(c => c.code === countryCode);
    if (!country?.productId || !products) return null;
    return products.find(p => p.id === country.productId);
  }, [products]);

  // Project 3D to 2D
  const project = useCallback((lat, lng, radius, centerX, centerY) => {
    const phi = (90 - lat) * (Math.PI / 180);
    const theta = (lng + rotation.y * (180 / Math.PI)) * (Math.PI / 180);
    
    const x = radius * Math.sin(phi) * Math.cos(theta);
    const y = radius * Math.cos(phi);
    const z = radius * Math.sin(phi) * Math.sin(theta);
    
    // Apply X rotation
    const cosX = Math.cos(rotation.x);
    const sinX = Math.sin(rotation.x);
    const y2 = y * cosX - z * sinX;
    const z2 = y * sinX + z * cosX;
    
    return {
      x: centerX + x,
      y: centerY - y2,
      z: z2,
      visible: z2 > -radius * 0.2
    };
  }, [rotation]);

  // Draw globe
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;
    const centerX = width / 2;
    const centerY = height / 2;
    const radius = Math.min(width, height) * 0.38;

    const draw = () => {
      ctx.clearRect(0, 0, width, height);

      // Globe glow
      const glowGradient = ctx.createRadialGradient(centerX, centerY, radius * 0.8, centerX, centerY, radius * 1.4);
      glowGradient.addColorStop(0, 'rgba(6, 182, 212, 0.15)');
      glowGradient.addColorStop(1, 'rgba(6, 182, 212, 0)');
      ctx.fillStyle = glowGradient;
      ctx.fillRect(0, 0, width, height);

      // Globe body
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
      const globeGradient = ctx.createRadialGradient(
        centerX - radius * 0.3, centerY - radius * 0.3, 0,
        centerX, centerY, radius
      );
      globeGradient.addColorStop(0, '#1e3a5f');
      globeGradient.addColorStop(0.5, '#0f2847');
      globeGradient.addColorStop(1, '#0a1929');
      ctx.fillStyle = globeGradient;
      ctx.fill();

      // Grid lines
      ctx.strokeStyle = 'rgba(6, 182, 212, 0.08)';
      ctx.lineWidth = 1;

      // Latitude lines
      for (let lat = -60; lat <= 60; lat += 30) {
        ctx.beginPath();
        for (let lng = 0; lng <= 360; lng += 5) {
          const pos = project(lat, lng, radius * 0.98, centerX, centerY);
          if (lng === 0) {
            ctx.moveTo(pos.x, pos.y);
          } else if (pos.visible) {
            ctx.lineTo(pos.x, pos.y);
          }
        }
        ctx.stroke();
      }

      // Longitude lines
      for (let lng = 0; lng < 360; lng += 30) {
        ctx.beginPath();
        for (let lat = -90; lat <= 90; lat += 5) {
          const pos = project(lat, lng, radius * 0.98, centerX, centerY);
          if (lat === -90) {
            ctx.moveTo(pos.x, pos.y);
          } else if (pos.visible) {
            ctx.lineTo(pos.x, pos.y);
          }
        }
        ctx.stroke();
      }

      // Draw connection arcs
      CONNECTION_ARCS.forEach(arc => {
        const fromCountry = COUNTRIES_DATA.find(c => c.code === arc.from);
        const toCountry = COUNTRIES_DATA.find(c => c.code === arc.to);
        if (!fromCountry || !toCountry) return;

        const from = project(fromCountry.lat, fromCountry.lng, radius * 0.98, centerX, centerY);
        const to = project(toCountry.lat, toCountry.lng, radius * 0.98, centerX, centerY);

        if (from.visible && to.visible) {
          // Calculate arc control point (above the surface)
          const midX = (from.x + to.x) / 2;
          const midY = (from.y + to.y) / 2;
          const dist = Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2));
          const arcHeight = dist * 0.3;
          
          ctx.beginPath();
          ctx.moveTo(from.x, from.y);
          ctx.quadraticCurveTo(midX, midY - arcHeight, to.x, to.y);
          
          const gradient = ctx.createLinearGradient(from.x, from.y, to.x, to.y);
          gradient.addColorStop(0, 'rgba(6, 182, 212, 0.6)');
          gradient.addColorStop(0.5, 'rgba(99, 102, 241, 0.6)');
          gradient.addColorStop(1, 'rgba(6, 182, 212, 0.6)');
          
          ctx.strokeStyle = gradient;
          ctx.lineWidth = 1.5;
          ctx.stroke();
        }
      });

      // Draw country points
      COUNTRIES_DATA.forEach(country => {
        const pos = project(country.lat, country.lng, radius * 0.98, centerX, centerY);
        
        if (pos.visible) {
          const hasProduct = country.productId !== null;
          const isHovered = hoveredCountry?.code === country.code;
          const baseSize = hasProduct ? 6 : 4;
          const size = isHovered ? baseSize * 1.5 : baseSize;
          
          // Outer glow
          if (hasProduct) {
            const glowSize = isHovered ? 20 : 12;
            const glow = ctx.createRadialGradient(pos.x, pos.y, 0, pos.x, pos.y, glowSize);
            glow.addColorStop(0, isHovered ? 'rgba(6, 182, 212, 0.5)' : 'rgba(6, 182, 212, 0.3)');
            glow.addColorStop(1, 'rgba(6, 182, 212, 0)');
            ctx.fillStyle = glow;
            ctx.beginPath();
            ctx.arc(pos.x, pos.y, glowSize, 0, Math.PI * 2);
            ctx.fill();
          }

          // Point
          ctx.beginPath();
          ctx.arc(pos.x, pos.y, size, 0, Math.PI * 2);
          ctx.fillStyle = hasProduct 
            ? (isHovered ? '#22d3ee' : '#14b8a6')
            : 'rgba(148, 163, 184, 0.5)';
          ctx.fill();

          // Pulse animation for available countries
          if (hasProduct && !isHovered) {
            const pulseSize = size + Math.sin(Date.now() / 500 + country.lat) * 3;
            ctx.beginPath();
            ctx.arc(pos.x, pos.y, pulseSize, 0, Math.PI * 2);
            ctx.strokeStyle = 'rgba(6, 182, 212, 0.3)';
            ctx.lineWidth = 1;
            ctx.stroke();
          }
        }
      });

      // Auto-rotate slowly when not dragging
      if (!isDragging && !targetRotation) {
        setRotation(prev => ({ ...prev, y: prev.y + 0.001 }));
      }

      animationRef.current = requestAnimationFrame(draw);
    };

    draw();
    return () => cancelAnimationFrame(animationRef.current);
  }, [rotation, hoveredCountry, isDragging, targetRotation, project]);

  // Mouse interactions
  const handleMouseMove = useCallback((e) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const rect = canvas.getBoundingClientRect();
    const x = (e.clientX - rect.left) * (canvas.width / rect.width);
    const y = (e.clientY - rect.top) * (canvas.height / rect.height);
    
    if (isDragging) {
      const dx = (x - lastMouse.x) * 0.005;
      const dy = (y - lastMouse.y) * 0.005;
      setRotation(prev => ({
        x: Math.max(-Math.PI / 2, Math.min(Math.PI / 2, prev.x - dy)),
        y: prev.y + dx
      }));
      setLastMouse({ x, y });
      return;
    }

    // Check hover on countries
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const radius = Math.min(canvas.width, canvas.height) * 0.38;

    let found = null;
    COUNTRIES_DATA.forEach(country => {
      const pos = project(country.lat, country.lng, radius * 0.98, centerX, centerY);
      if (pos.visible) {
        const dist = Math.sqrt(Math.pow(x - pos.x, 2) + Math.pow(y - pos.y, 2));
        if (dist < 15 && country.productId) {
          found = country;
        }
      }
    });
    setHoveredCountry(found);
  }, [isDragging, lastMouse, project]);

  const handleMouseDown = useCallback((e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    setLastMouse({
      x: (e.clientX - rect.left) * (canvasRef.current.width / rect.width),
      y: (e.clientY - rect.top) * (canvasRef.current.height / rect.height)
    });
    setIsDragging(true);
  }, []);

  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
  }, []);

  const handleClick = useCallback((e) => {
    if (hoveredCountry && onCountrySelect) {
      onCountrySelect(hoveredCountry);
    }
  }, [hoveredCountry, onCountrySelect]);

  return (
    <div ref={containerRef} className="relative w-full h-full">
      <canvas
        ref={canvasRef}
        width={800}
        height={800}
        className="w-full h-full cursor-grab active:cursor-grabbing"
        onMouseMove={handleMouseMove}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onClick={handleClick}
        style={{ touchAction: 'none' }}
      />
      
      {/* Tooltip */}
      <AnimatePresence>
        {hoveredCountry && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-slate-900/95 backdrop-blur-xl border border-teal-500/30 rounded-xl px-4 py-3 shadow-lg pointer-events-none"
          >
            <div className="flex items-center space-x-3">
              <MapPin className="w-5 h-5 text-teal-400" />
              <div>
                <p className="text-white font-semibold">{hoveredCountry.name}</p>
                {getProductForCountry(hoveredCountry.code) && (
                  <p className="text-teal-400 text-sm font-mono">
                    da €{parseFloat(getProductForCountry(hoveredCountry.code)?.price).toFixed(2)}
                  </p>
                )}
              </div>
              <ChevronRight className="w-4 h-4 text-slate-400" />
            </div>
            <p className="text-xs text-slate-500 mt-1">Click per vedere i piani</p>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Legend */}
      <div className="absolute top-4 right-4 bg-slate-900/80 backdrop-blur-sm rounded-lg px-3 py-2 text-xs space-y-1">
        <div className="flex items-center space-x-2">
          <div className="w-3 h-3 rounded-full bg-teal-500" />
          <span className="text-slate-300">eSIM disponibile</span>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 rounded-full bg-slate-500" />
          <span className="text-slate-400">Prossimamente</span>
        </div>
      </div>

      {/* Drag hint */}
      <div className="absolute bottom-4 right-4 text-xs text-slate-500">
        Trascina per ruotare
      </div>
    </div>
  );
}

// Country popup with plans
export function CountryPlansPopup({ country, products, onClose, onAddToCart }) {
  const product = products?.find(p => p.id === country.productId);
  
  const getMetaValue = (prod, key) => {
    const meta = prod?.meta_data?.find(m => m.key === key);
    return meta?.value || '-';
  };

  // Also show regional plans that cover this country
  const regionalPlans = products?.filter(p => {
    const coverage = getMetaValue(p, 'country')?.toLowerCase();
    return coverage === 'europa' || coverage === 'globale';
  }) || [];

  const allPlans = product ? [product, ...regionalPlans] : regionalPlans;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        className="relative bg-slate-900 border border-white/10 rounded-2xl max-w-lg w-full max-h-[80vh] overflow-hidden"
        onClick={e => e.stopPropagation()}
        data-testid="country-popup"
      >
        {/* Header */}
        <div className="relative h-32 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-teal-500/20 to-indigo-500/20" />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900 to-transparent" />
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 bg-black/30 rounded-full hover:bg-black/50 transition-colors"
          >
            <X className="w-5 h-5 text-white" />
          </button>
          <div className="absolute bottom-4 left-6">
            <div className="flex items-center space-x-3">
              <MapPin className="w-6 h-6 text-teal-400" />
              <h2 className="text-2xl font-bold text-white font-outfit">{country.name}</h2>
            </div>
          </div>
        </div>

        {/* Plans */}
        <div className="p-6 max-h-[50vh] overflow-y-auto">
          {allPlans.length === 0 ? (
            <div className="text-center py-8">
              <Wifi className="w-12 h-12 text-slate-600 mx-auto mb-3" />
              <p className="text-slate-400">Nessun piano disponibile per questo paese.</p>
              <p className="text-slate-500 text-sm mt-2">Prova con un piano regionale o globale.</p>
            </div>
          ) : (
            <div className="space-y-4">
              <p className="text-slate-400 text-sm">
                {allPlans.length} {allPlans.length === 1 ? 'piano disponibile' : 'piani disponibili'}
              </p>
              
              {allPlans.map(plan => (
                <div
                  key={plan.id}
                  className="bg-white/5 border border-white/10 rounded-xl p-4 hover:border-teal-500/50 transition-colors"
                >
                  <div className="flex items-start justify-between">
                    <div>
                      <h3 className="text-white font-semibold">{plan.name}</h3>
                      <div className="flex items-center space-x-4 mt-2 text-sm">
                        <span className="flex items-center space-x-1 text-teal-400">
                          <Wifi className="w-4 h-4" />
                          <span className="font-mono">{getMetaValue(plan, 'data')}</span>
                        </span>
                        <span className="flex items-center space-x-1 text-slate-400">
                          <Clock className="w-4 h-4" />
                          <span>{getMetaValue(plan, 'validity')}</span>
                        </span>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-2xl font-bold text-white font-mono">€{parseFloat(plan.price).toFixed(2)}</p>
                    </div>
                  </div>
                  
                  <button
                    onClick={() => onAddToCart(plan)}
                    className="w-full mt-4 bg-teal-500 hover:bg-teal-400 text-black font-semibold py-2 rounded-full transition-all flex items-center justify-center space-x-2"
                    data-testid={`popup-add-to-cart-${plan.id}`}
                  >
                    <ShoppingCart className="w-4 h-4" />
                    <span>Aggiungi al Carrello</span>
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </motion.div>
    </motion.div>
  );
}
